export function getErrMsg(err) {
  if (err?.response?.data?.detail) {
    const d = err.response.data.detail;
    if (typeof d === 'string') return d;
    if (Array.isArray(d)) return d.map(e => e.msg || JSON.stringify(e)).join('; ');
    return String(d);
  }
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.response?.status) return `Server error (${err.response.status})`;
  if (err?.message) return err.message === 'Network Error' ? 'Unable to reach server. Please check your connection.' : err.message;
  return 'Something went wrong';
}
